function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { Disclosure } from "@headlessui/react";
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { isTruthy } from "../../../utils/isTruthy";
import { DropdownIcon } from "../../Molecules/icons";
import { ParagraphChart } from "./ParagraphChart";
import { ParagraphText } from "./ParagraphText";
import { ParagraphTwoColumnsImageText } from "./ParagraphTwoColumnsImageText";
import { ParagraphTwoColumnsText } from "./ParagraphTwoColumnsText";
import { ParagraphVideos } from "./ParagraphVideos";
export function ParagraphAccordion(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx({
            "container-page": !props.isNested
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-text"
    }, /*#__PURE__*/ React.createElement(Disclosure, null, function(param) {
        var open = param.open;
        var _props_content, _props_content1;
        return /*#__PURE__*/ React.createElement("div", {
            className: "border-b border-green-500 px-3 md:px-[1.875rem] pb-[1.375rem] my-[1.375rem]"
        }, /*#__PURE__*/ React.createElement(Disclosure.Button, {
            className: clsx("flex prose justify-between items-center w-full focus-dark text-green-500 text-start")
        }, /*#__PURE__*/ React.createElement("h3", {
            className: clsx(props.titleStyle, "m-0 text-xl leading-xl md:text-2xl md:leading-2xl")
        }, props.title), /*#__PURE__*/ React.createElement("div", {
            className: "m-2 w-4 h-2.5"
        }, /*#__PURE__*/ React.createElement(DropdownIcon, {
            isOpen: open,
            className: "text-green-500"
        }))), /*#__PURE__*/ React.createElement(AnimatePresence, null, !!((_props_content = props.content) === null || _props_content === void 0 ? void 0 : _props_content.length) && open && /*#__PURE__*/ React.createElement(Disclosure.Panel, {
            as: motion.div,
            static: true,
            key: "content",
            initial: "collapsed",
            animate: "expanded",
            exit: "collapsed",
            variants: {
                expanded: {
                    opacity: 1,
                    height: "auto",
                    transition: {
                        duration: 0.3,
                        ease: "easeIn",
                        opacity: {
                            delay: 0.2
                        }
                    }
                },
                collapsed: {
                    opacity: 0,
                    height: 0,
                    transition: {
                        duration: 0.3,
                        ease: "easeOut",
                        height: {
                            delay: 0.2
                        }
                    }
                }
            },
            className: "nested-container prose"
        }, (_props_content1 = props.content) === null || _props_content1 === void 0 ? void 0 : _props_content1.filter(isTruthy).map(function(paragraph, index) {
            //TODO support all paragraph once implemented
            switch(paragraph.__typename){
                case "ParagraphText":
                    return /*#__PURE__*/ React.createElement(ParagraphText, _object_spread_props(_object_spread({}, paragraph), {
                        markeupClassNames: {
                            p: " last:mb-0"
                        },
                        isNested: true
                    }));
                case "ParagraphChart":
                    return /*#__PURE__*/ React.createElement(ParagraphChart, _object_spread_props(_object_spread({}, parent), {
                        key: index
                    }));
                //note than the component is different than the one in the page
                case "ParagraphTwoColumnsImageText":
                    var _props_hideTitle;
                    return /*#__PURE__*/ React.createElement(ParagraphTwoColumnsImageText, _object_spread_props(_object_spread({}, paragraph), {
                        isNested: true,
                        hideTitle: (_props_hideTitle = props.hideTitle) !== null && _props_hideTitle !== void 0 ? _props_hideTitle : false
                    }));
                case "ParagraphVideos":
                    return /*#__PURE__*/ React.createElement(ParagraphVideos, paragraph);
                case "ParagraphTwoColumnsText":
                    return /*#__PURE__*/ React.createElement(ParagraphTwoColumnsText, _object_spread_props(_object_spread({}, paragraph), {
                        isNested: true
                    }));
            }
        }))));
    }))));
}
